import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
// Lazy load non-landing pages to reduce initial bundle
const About = lazy(() => import('./pages/About').then(m => ({
  default: m.About
})));
const HowWeFixIt = lazy(() => import('./pages/HowWeFixIt').then(m => ({
  default: m.HowWeFixIt
})));
const WhatsWrong = lazy(() => import('./pages/WhatsWrong').then(m => ({
  default: m.WhatsWrong
})));
const Book = lazy(() => import('./pages/Book').then(m => ({
  default: m.Book
})));
const WhereAIFits = lazy(() => import('./pages/WhereAIFits').then(m => ({
  default: m.WhereAIFits
})));
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    // If there's a hash, let the browser handle anchor scrolling
    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 0);
    } else {
      // No hash, scroll to top
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen flex flex-col" data-id="element-2">
        <Navigation data-id="element-3" />
        <Suspense fallback={<div className="min-h-screen bg-[#1D2A3A]" data-id="element-5" />} data-id="element-4">
          <AnimatePresence mode="wait" data-id="element-6">
            <Routes data-id="element-7">
              <Route path="/" element={<Home data-id="element-9" />} data-id="element-8" />
              <Route path="/about-john" element={<About data-id="element-11" />} data-id="element-10" />
              <Route path="/whats-wrong" element={<WhatsWrong data-id="element-13" />} data-id="element-12" />
              <Route path="/how-we-fix-it" element={<HowWeFixIt data-id="element-15" />} data-id="element-14" />
              <Route path="/where-ai-fits" element={<WhereAIFits data-id="element-17" />} data-id="element-16" />
              <Route path="/book" element={<Book data-id="element-19" />} data-id="element-18" />
            </Routes>
          </AnimatePresence>
        </Suspense>
        <Footer data-id="element-20" />
      </div>
    </BrowserRouter>;
}